import { useEffect, useState } from 'react';
import { projects as baseProjects } from '../model/projects';
import { fetchLikes } from '../api/likes';

export function useProjectsWithLikes() {
  const [projects, setProjects] = useState(baseProjects);

  useEffect(() => {
    fetchLikes().then((likes) => {
      if (Object.keys(likes).length === 0) return;

      setProjects((prev) =>
        prev.map((project) => ({
          ...project,
          likes:
            likes[project.id] !== undefined
              ? Number(likes[project.id])
              : project.likes,
        }))
      );
    });
  }, []);

  return projects;
}
